<div *ngIf="!hasWritePermission()">{{localizationKeys.aumico_reports_write_permission_error | i18next}}</div>
<div *ngIf="hasWritePermission()">
    {{localizationKeys.aumico_reports_placeholder_needs_implementation | i18next }}
    <div>
        <button aum-icon-button color="basic">New</button>
    </div>
</div>
